import React from "react";

// Official IEPEM emblem (framed badge). Self-contained artwork works on both
// dark and light backgrounds, so the `tone` prop is kept only for API compatibility.
const Logo = ({ tone = "light", className = "" }) => {
  void tone;
  return (
    <img
      src="/brand/logo-new.png?v=2"
      alt="I.E.P.E.M. S.r.l. — since 1982"
      className={`h-20 sm:h-24 w-auto object-contain ${className}`}
    />
  );
};

export default Logo;
